const tmp = typeof settings === "undefined" ? {} : settings;

export default _.get(tmp, 'services', {});
